export const generateNameOption = (option, t, nameWithLanguage) => {
  if (option?.remainingQuantity <= 0) {
    return `${option[nameWithLanguage]} - ${t("sold_out_ticket")}`;
  }
  if (option?.numberCanBuy <= 0) {
    return `${option[nameWithLanguage]} - ${t("limit_ticket")}`;
  }
  return option[nameWithLanguage];
};
